var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9987 9.1653H8.66536V12.4986C8.66536 12.6754 8.59513 12.845 8.4701 12.97C8.34508 13.0951 8.17551 13.1653 7.9987 13.1653C7.82189 13.1653 7.65232 13.0951 7.52729 12.97C7.40227 12.845 7.33203 12.6754 7.33203 12.4986V9.1653H3.9987C3.82189 9.1653 3.65232 9.09507 3.52729 8.97004C3.40227 8.84502 3.33203 8.67545 3.33203 8.49864C3.33203 8.32183 3.40227 8.15226 3.52729 8.02723C3.65232 7.90221 3.82189 7.83197 3.9987 7.83197H7.33203V4.49864C7.33203 4.32183 7.40227 4.15226 7.52729 4.02723C7.65232 3.90221 7.82189 3.83197 7.9987 3.83197C8.17551 3.83197 8.34508 3.90221 8.4701 4.02723C8.59513 4.15226 8.66536 4.32183 8.66536 4.49864V7.83197H11.9987C12.1755 7.83197 12.3451 7.90221 12.4701 8.02723C12.5951 8.15226 12.6654 8.32183 12.6654 8.49864C12.6654 8.67545 12.5951 8.84502 12.4701 8.97004C12.3451 9.09507 12.1755 9.1653 11.9987 9.1653Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.ae0615fc2850fdf5b68f23609be2a46d.svg";
export { ForwardRef as ReactComponent };